import request from '../axios'
import requestSec from '../axiosSec'

// 工具箱
// 指令列表数据
export const cmdcommandList = params => request({
	url: 'cmd/cmdcommand/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 禁用、启用快捷指令
export const cmdcommandChangeShortcutCode = data => request({
	url: 'cmd/cmdcommand/changeShortcutCode',
	method: 'post',
	data: data
})

// 获取服务器列表
export const toolboxterminalserverList = params => request({
	url: 'toolbox/toolboxterminalserver/list',
	method: 'get',
	params: params
})

// 添加服务器
export const toolboxterminalserverSave = data => request({
	url: 'toolbox/toolboxterminalserver/save',
	method: 'post',
	data: data
})

// 编辑服务器
export const toolboxterminalserverUpdate = data => request({
	url: 'toolbox/toolboxterminalserver/update',
	method: 'post',
	data: data
})

// 删除服务器
export const toolboxterminalserverDelete = data => request({
	url: 'toolbox/toolboxterminalserver/delete',
	method: 'post',
	data: data
})

// 移动
export const toolboxterminalserverMove = params => request({
	url: 'toolbox/toolboxterminalserver/move',
	method: 'get',
	params: params
})

// 产品类型
export const sysinstructionProductCategory = params => request({
	url: 'sys/sysinstruction/productCategory',
	method: 'get',
	params: params
})

// 说明书列表
export const sysinstructionList = params => request({
	url: 'sys/sysinstruction/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 新增说明书-保存按钮
export const sysinstructionSave = data => request({
	url: 'sys/sysinstruction/save',
	method: 'post',
	data: data
})

// 获取说明书详情
export const sysinstructionInfo = params => request({
	url: 'sys/sysinstruction/info/' + params.id,
	method: 'get'
})

// 使用说明书ID换取预览code(未发布的)
export const sysinstructionPreviewById = params => request({
	url: 'sys/sysinstruction/previewById/' + params.id,
	method: 'get'
})

// 编辑说明书-保存按钮
export const sysinstructionUpdate = data => request({
	url: 'sys/sysinstruction/update',
	method: 'post',
	data: data
})

// 说明书--向上移动/向下移动
export const sysinstructionMove = params => request({
	url: 'sys/sysinstruction/move',
	method: 'get',
	params: params
})

// 删除说明书
export const sysinstructionDelete = data => request({
	url: 'sys/sysinstruction/delete',
	method: 'post',
	data: data
})

// 预览内容提交（实时查看的）
export const sysinstructionPreview = data => request({
	url: 'sys/sysinstruction/preview',
	method: 'post',
	data: data
})

// 更新文档列表
export const sysupdatedocumentList = params => request({
	url: 'sys/sysupdatedocument/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取项目列表（无分页）绑定项目数据
export const projecttrackingprojectListAll = params => request({
	url: 'tracking/projecttrackingproject/listAll',
	method: 'get',
	params: params
})

// 新增更新文档
export const sysupdatedocumentSave = data => request({
	url: 'sys/sysupdatedocument/save',
	method: 'post',
	data: data
})

// 根据ID获取文档详情
export const sysupdatedocumentInfo = params => request({
	url: 'sys/sysupdatedocument/info/' + params.id,
	method: 'get'
})

// 编辑更新文档
export const sysupdatedocumentUpdate = data => request({
	url: 'sys/sysupdatedocument/update',
	method: 'post',
	data: data
})

// 更新文档--向上移动/向下移动
export const sysupdatedocumentMove = params => request({
	url: 'sys/sysupdatedocument/move',
	method: 'get',
	params: params
})

// 删除更新文档
export const sysupdatedocumentDelete = data => request({
	url: 'sys/sysupdatedocument/delete',
	method: 'post',
	data: data
})

// 获取日志列表
export const sysupdatedocumentlogList = params => request({
	url: 'sys/sysupdatedocumentlog/list',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260312修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 获取更新类型
export const sysupdatedocumentlogUpdateType = params => request({
	url: 'sys/sysupdatedocumentlog/updateType',
	method: 'get',
	params: params
})

// 根据日志ID获取详情
export const sysupdatedocumentlogInfo = params => request({
	url: 'sys/sysupdatedocumentlog/info/' + params.id,
	method: 'get'
})

// 新增日志
export const sysupdatedocumentlogSave = data => request({
	url: 'sys/sysupdatedocumentlog/save',
	method: 'post',
	data: data
})

// 编辑日志
export const sysupdatedocumentlogUpdate = data => request({
	url: 'sys/sysupdatedocumentlog/update',
	method: 'post',
	data: data
})

// 删除日志
export const sysupdatedocumentlogDelete = data => request({
	url: 'sys/sysupdatedocumentlog/delete',
	method: 'post',
	data: data
})

// 根据项目 获取所有需求数据
export const projecttrackingmoduleModuleRequirementListByProjectId = params => request({
	url: 'tracking/projecttrackingmodule/moduleRequirementListByProjectId',
	method: 'get',
	params: params
})

// 获取文件上传的临时密钥（不会在后端生成上传记录）
export const sysimportUploadtemporaryKey = data => request({
	url: 'sys/sysimport/uploadtemporaryKey',
	method: 'post',
	data: data
})

// 刷新导入信息
export const sysupdatedocumentlogUpdateDocumentRequirement = data => request({
	url: 'sys/sysupdatedocumentlog/updateDocumentRequirement',
	method: 'post',
	data: data
})